

import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import RateDetail from './RateDetail'
import * as rateAction from '../../../../../actions/rateAction';
import * as hotelActions from '../../../../../actions/hotelAction';
import * as amenityActions from '../../../../../actions/amenityAction';

const mapStateToProps = state => {
    return {
        rateState: state.rateReducer,
        uploadState: state.uploadReducer,
        amenityState: state.amenityReducer,
        hotelState: state.hotelReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getRate: (id) => dispatch(rateAction.getRate(id)),
        getHotelDetail: (id) => dispatch(hotelActions.getHotelDetail(id)),
        getListAmenities: () => dispatch(amenityActions.getListAmenity()),
        createRateTranslate: (rate, language, targetLanguages) => dispatch(rateAction.createRateTranslate(rate, language, targetLanguages)),
        updateRateTranslate: (rate, language, targetLanguages) => dispatch(rateAction.updateRateTranslate(rate, language, targetLanguages)),
        deleteRateTranslate: (rate, refreshParams) => dispatch(rateAction.deleteRateTranslate(rate, refreshParams)),
        updateCancelPolicys: (cancelPolicys, id) => dispatch(rateAction.updateCancelPolicys(cancelPolicys, id)),
        syncCancelPolicys: (cancelPolicys, id) => dispatch(rateAction.syncCancelPolicys(cancelPolicys, id)),
        createRateBeachVilla: (id, rate) => dispatch(rateAction.createRateBeachVilla(id, rate)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(RateDetail));
